import { defineType } from "sanity";
import { contentFilterPreview } from "../../common/localization";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "menuItem",
  title: "Menu Item",
  preview: {
    select: {
      title: "target.title",
      title2: "target.heading.title",
      filters: "filters"
    },
    prepare({ title, title2, filters }) {
      return {
        title:
          multilingualStringPreview(title) || multilingualStringPreview(title2),
        subtitle: contentFilterPreview(filters)
      };
    }
  },
  fields: [
    {
      name: "target",
      title: "Target",
      type: "reference",
      validation: (Rule) => Rule.required(),
      to: [
        { type: "page" },
        { type: "landingPage" },
        { type: "offersTermsAndConditions" }
      ]
    },
    {
      name: "filters",
      title: "Filters",
      description:
        "If present, the menu item will only appear for the below selected filters",
      type: "array",
      of: [
        {
          type: "locationFilter"
        },
        {
          type: "airNonAirFilter"
        }
      ]
    }
  ]
});
